import React, { Component } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import Notice from "Components/Notice";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils.js";
import platform from "Pub/js/platform";
import { getStore, setStore } from "Pub/js/storageUtils";
import RSAUtils from "Pub/js/security.js";
const FormItem = Form.Item;
const { NCButton } = platform.base;
const Cryptograph = platform.Cryptograph;

class phoneEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prompt: false,
            num: 0,
        };
    }
    /**
     * 获取验证码
     */
    handleGetCaptcha = () => {
        const formObj = this.props.formObj;
        let { json, exponent, modulus, setValWhenGetCaptcha } = this.props;
        // let phoneVale = formObj.getFieldValue("phone");
        // let RSAkey = RSAUtils.getKeyPair(exponent, "", modulus);
        const cipher = new Cryptograph({});
        let RSAkey = cipher.getAsyncPublicKey();
        formObj.validateFields(["pw", "phone"], (error, values) => {

            // console.log(error, values);
            if (!error) {
                if (this.state.num > 0) {
                    return;
                }
                if (this.state.num == 0) {
                    Ajax({
                        toastContainer: this.props.pageRef,
                        url: `/nccloud/platform/telphone/sendCaptchaToTelphone.do`,
                        data: {
                            telphone: values.phone,
                            // password: RSAUtils.encryptedString(RSAkey, values.pw),
                            password: cipher.asymmetricEncrypt(values.pw, RSAkey),
                        },
                        info: {
                            name: langCheck('UserInfo-000006', 'pages', json), /* 国际化处理： 发送验证码*/
                            action: langCheck('UserInfo-000006', 'pages', json), /* 国际化处理： 发送验证码*/
                        },
                        // loading: true,
                        success: ({ data: { data } }) => {
                            setValWhenGetCaptcha(values.phone);
                            if (data.status) {
                                this.setState(
                                    {
                                        prompt: true,
                                        num: 60,
                                    },
                                    this.captchaCount,
                                );
                            }
                            Notice({
                                status: data.status ? "success" : "error",
                                msg: data.msg,
                                container: this.props.pageRef
                            });
                        },
                    });
                }
            }
        });
    };
    /**
     * 验证码计数
     */
    captchaCount = () => {
        let fun = () => {
            let num = this.state.num;
            if (num === 0) {
                this.setState({ prompt: false });
                clearInterval(timer);
            } else {
                num--;
            }
            this.setState({ num });
        };
        let timer = setInterval(fun, 1000);
    };

    checkPhone = async (rule, value, callback) => {
        let { json, mobile, infoType } = this.props;
        let STOREFORINFODATA = getStore("STOREFORINFODATA");
        let telphone = infoType=== '2'?STOREFORINFODATA.telphone : mobile;

        if (value == telphone) {
            throw new Error(langCheck('UserInfo-000056', 'pages', json));
        }
    }
    render() {
        let { layout, formObj, json } = this.props;
        let { getFieldDecorator } = formObj;

        return (
            <Form>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label={langCheck('UserInfo-000007', 'pages', json)}/* 国际化处理： 密码*/
                >
                    {getFieldDecorator("pw", {
                        rules: [
                            {
                                required: true,
                                message: langCheck('UserInfo-000008', 'pages', json), /* 国际化处理： 请输入密码！*/
                            },
                        ],
                    })(<Input type="password" autocomplete="new-password" fieldid="password" />)}
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label={langCheck('UserInfo-000040', 'pages', json)} /* 国际化处理： 手机号*/
                >
                    {getFieldDecorator("phone", {
                        rules: [
                            {
                                pattern: /^134[0-8]\d{7}$|^13[^4]\d{8}$|^14[5-9]\d{8}$|^15[^4]\d{8}$|^16[6]\d{8}$|^17[0-8]\d{8}$|^18[\d]{9}$|^19[8,9]\d{8}$/,
                                message: langCheck('UserInfo-000050', 'pages', json), /* 国际化处理： 输入不是有效的手机号！*/
                            },
                            { validator: this.checkPhone },
                            {
                                required: true,
                                message: langCheck('UserInfo-000049', 'pages', json), /* 国际化处理： 请输入手机号!*/
                            },
                        ],
                    })(<Input fieldid="phone" />)}
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label={langCheck('UserInfo-000011', 'pages', json)}/* 国际化处理： 验证码*/
                    extra={
                        this.state.prompt
                            ? langCheck('UserInfo-000041', 'pages', json) /* 国际化处理： 验证码已发送至您的手机，请注意查收！*/
                            : ""
                    }
                >
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator("captcha", {
                                rules: [
                                    { required: true, message: langCheck('UserInfo-000013', 'pages', json) }, /* 国际化处理： 请输入验证码!*/
                                ],
                            })(<Input fieldid="captcha" />)}
                        </Col>
                        <Col span={12}>
                            <NCButton
                                colors="primary"
                                className="captcha-btn"
                                onClick={this.handleGetCaptcha}
                                fieldid="captcha"
                            >
                                {langCheck('UserInfo-000014', 'pages', json)/* 国际化处理： 获取验证码*/}
                                {this.state.num > 0
                                    ? `(${this.state.num})`
                                    : ""}
                            </NCButton>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}
export default phoneEdit;
